import { Typography } from "@material-ui/core";

export const TwentyYear = () => {
  return (
    <Typography style={{ color: "#979797" }} align="right">
      20Y
    </Typography>
  );
};
